import { render } from "./MostPopular.vue?vue&type=template&id=e0a5ddac"
import script from "./MostPopular.vue?vue&type=script&lang=js"
export * from "./MostPopular.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__